import propTypes from 'prop-types';
import { Trans, useTranslation } from 'react-i18next';

import { Modal } from '@kiper/ui';
import {
  TutorialSteps,
  TutorialStep,
  StepText,
  StepCopy,
  CopyHint,
  TutorialMedia,
} from '../styles';

const TutorialModal = ({
  open,
  toggle,
  app,
  appLabel,
  stepKeys,
  media,
  copyTextButton,
}) => {
  const [t] = useTranslation('login');

  return (
    <Modal
      open={open}
      toggle={toggle}
      size="sm"
      title={t('two-step.enroll.tutorial.title', { app: appLabel })}
    >
      <div>
        <TutorialSteps>
          {stepKeys.map((key, index) => (
            <TutorialStep key={key}>
              <StepText>
                <Trans
                  t={t}
                  i18nKey={`two-step.enroll.tutorial.${app}.${key}`}
                />
                {app === 'ente' && key === 'step2' && (
                  <StepCopy>
                    <CopyHint>
                      {t('two-step.enroll.tutorial.copy-hint')}
                    </CopyHint>
                    {copyTextButton}
                  </StepCopy>
                )}
                {media && media[index] && (
                  <TutorialMedia>
                    <img
                      src={media[index]}
                      alt={t('two-step.enroll.tutorial.step-alt', {
                        app: appLabel,
                        step: index + 1,
                      })}
                    />
                  </TutorialMedia>
                )}
              </StepText>
            </TutorialStep>
          ))}
        </TutorialSteps>
      </div>
    </Modal>
  );
};

export default TutorialModal;

TutorialModal.propTypes = {
  open: propTypes.bool.isRequired,
  toggle: propTypes.func.isRequired,
  app: propTypes.string.isRequired,
  appLabel: propTypes.string.isRequired,
  stepKeys: propTypes.arrayOf(propTypes.string).isRequired,
  media: propTypes.arrayOf(propTypes.string),
  copyTextButton: propTypes.node,
};

TutorialModal.defaultProps = {
  media: null,
  copyTextButton: null,
};
